import React, { useState } from 'react'
import { ConfigureColumnsButton } from 'ui-components'
import { useSelector } from 'klyva'
import { TaskT } from 'ui-io/task-io/task-t'
import { Button, ButtonGroup } from '@blueprintjs/core'

import {
  TaskColumnId,
  TaskColumnEntry,
  TaskBulkToggleKey,
  TaskOrderOptionKey,
  TaskColumnSettingsAtom,
} from '../task-columns'
// import ExportTsvButton from '../export-tsv-button'
// import generateTsv from './generate-tsv'
// import UnblockTaskOnRadarDialog from './unblock-task-on-radar-dialog'
import { InboxViewT } from '../../../pages/tasks/inbox-views'

const TableActions = ({
  columnSettingsAtom,
  sortedTasks,
  view,
  togglingDisabledColumns,
}: {
  columnSettingsAtom: TaskColumnSettingsAtom
  sortedTasks: TaskT[]
  view: InboxViewT
  togglingDisabledColumns: Set<TaskColumnId>
}) => {
  const [unblockDialogOpen, setUnblockDialogOpen] = useState(false)
  const columnIds = useSelector(
    columnSettingsAtom,
    ({ enabledColumnIds }) => enabledColumnIds,
  )

  const bulkActionPage = view === 'Approved'
  return (
    <ButtonGroup>
      <ConfigureColumnsButton<
        TaskColumnId,
        TaskColumnEntry,
        TaskBulkToggleKey,
        TaskOrderOptionKey
      >
        columnSettingsAtom={columnSettingsAtom}
        togglingDisabledColumns={togglingDisabledColumns}
      />
      {/* <ExportTsvButton<TaskT, TaskColumnId>
        columnIds={columnIds}
        sortedRows={sortedTasks}
        generateTsv={generateTsv}
      /> */}
      {/* {bulkActionPage && (
        <>
          <UnblockTaskOnRadarDialog
            isOpen={unblockDialogOpen}
            onClose={() => setUnblockDialogOpen(false)}
          />
          <Button onClick={() => setUnblockDialogOpen(true)}>
            Unblock on Radar(s)
          </Button>
        </>
      )} */}
    </ButtonGroup>
  )
}

export default TableActions
